import { CellClickedEvent, ICellRendererParams } from '@access-erp/ui-components';
import styled from 'styled-components';

import { getFullWorkspaceLink } from '@/utils/getLinkWithSubscriptionId.utils';

export const shouldSkipCellClickNavigation = (event: CellClickedEvent): boolean => {
  const browserEvent = event.event as MouseEvent | undefined;
  // Skip navigation for Ctrl+click, Cmd+click, or middle-click
  return !!(browserEvent?.ctrlKey || browserEvent?.metaKey || browserEvent?.button === 1);
};

export const StyledLink = styled.a`
  color: ${({ theme }) => theme?.palette?.primary?.main ?? '#036D83'} !important;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme?.palette?.primary?.light ?? '#208da5'} !important;
    text-decoration: underline;
  }
`;

export interface HrefGeneratorProps<TData = unknown> {
  params: ICellRendererParams<TData>;
  data: TData | undefined;
  value: unknown;
  rowIndex: number;
  searchString?: string;
}

export const createLinkCellRenderer = <TData = any>(
  getHref: (props: HrefGeneratorProps<TData>) => string | undefined
) => {
  return (params: ICellRendererParams<any>) => {
    if (!params.value) {
      return null;
    }

    const searchString = params.context?.serverSide?.current?.search;
    const internalHref = getHref({
      params,
      data: params.data as TData | undefined,
      value: params.value,
      rowIndex: params.node?.rowIndex ?? 0,
      searchString,
    }) ?? '#';

    const href = internalHref === '#' ? '#' : getFullWorkspaceLink(internalHref);

    return (
      <StyledLink
        href={href}
        onClick={(e) => {
          // For Ctrl+click or Cmd+click: let browser open new tab, but stop propagation
          if ((e.ctrlKey || e.metaKey) && e.button === 0) {
            e.stopPropagation();
            return;
          }
          // For normal left-click: prevent browser navigation and let onCellClicked handle it
          if (e.button === 0) {
            e.preventDefault();
          }
        }}
      >
        {params.value}
      </StyledLink>
    );
  };
};
